import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

function displayOnlyOn(allowedDisplayOnPropType) {
  return ({ displayOn }) => (displayOn === allowedDisplayOnPropType ? 'flex' : 'none');
}

const CTABlock = styled(Block)`
  ${paddingBuilder.all(0)};

  display: ${displayOnlyOn('mobile')};
  align-items: center;

  ${tablet768`
    ${paddingBuilder.all(2.5, 0, 0, 0)};

    display: ${displayOnlyOn('tabletAndLarger')};
    align-items: flex-start;
  `}
`;

CTABlock.propTypes = {
  displayOn: PropTypes.oneOf(['mobile', 'tabletAndLarger']).isRequired,
};

export function MobileOnlyCTABlock(props) {
  return <CTABlock {...props} displayOn="mobile" />;
}

MobileOnlyCTABlock.displayName = 'MobileOnlyCTABlock';

export function TabletAndLargerOnlyCTABlock(props) {
  return <CTABlock {...props} displayOn="tabletAndLarger" />;
}

TabletAndLargerOnlyCTABlock.displayName = 'TabletAndLargerOnlyCTABlock';
